import useCompetencyService from '../competencyService';
import { Show } from 'framework/show';
import { ShowPageLayout, BigSectionRow } from 'framework/ui/layout';
import SingleCompetencyBreadcrumbs from '../shared/SingleCompetencyBreadcrumbs';
import CompetencyEntityHeader from '../shared/CompetencyEntityHeader';
import CompetencyAreasField from '../shared/field/CompetencyAreasField';
import { HtmlField, BulletedListField } from 'framework/ui/field';
import CompetencyMenu from 'domain/people/career/qualification/competency/shared/CompetencyMenu';
import { ReplaceUrlWithLink } from 'framework/utils';
import { useCompetencyId } from '../competencyRouting';
import { Box } from '@mui/material';
import { viewSingleEntryListSx, viewSingleEntrySx } from 'framework/ui/styles';

const CompetencyViewPage = () => {
  const id = useCompetencyId();
  const { getById } = useCompetencyService();

  return (
    <Show getDataMethod={() => getById(id)}>
      <ShowPageLayout
        breadcrumbs={<SingleCompetencyBreadcrumbs />}
        entityHeader={<CompetencyEntityHeader />}
        menu={<CompetencyMenu />}
      >
        <Box sx={[viewSingleEntrySx, viewSingleEntryListSx]}>
          <BigSectionRow>
            <BulletedListField source="evidence" label="Valid work product evidence or counter-examples" />
          </BigSectionRow>

          <BigSectionRow>
            <ReplaceUrlWithLink>
              <HtmlField source="details.requirements" label="Requirements" />
            </ReplaceUrlWithLink>
          </BigSectionRow>

          <BigSectionRow>
            <ReplaceUrlWithLink>
              <HtmlField source="details.theory" label="Recommended theory" />
            </ReplaceUrlWithLink>
          </BigSectionRow>

          <BigSectionRow>
            <CompetencyAreasField source="areas" label="Competency areas" />
          </BigSectionRow>
        </Box>
      </ShowPageLayout>
    </Show>
  );
};

export default CompetencyViewPage;
